module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTStd-LtCn.69bb6534.otf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/fonts/Helvetica/HelveticaNeueLTStd-LtCn.otf
// module id = 732
// module chunks = 0